const IV_BYTES = 12
const KEY_BYTES = 32

export function base64urlEncode(bytes: Uint8Array): string {
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]!)
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function base64urlDecode(s: string): Uint8Array<ArrayBuffer> {
  const padded = s.replace(/-/g, '+').replace(/_/g, '/') + '=='.slice(0, (4 - (s.length % 4)) % 4)
  const binary = atob(padded)
  const out = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) out[i] = binary.charCodeAt(i)
  return out
}

export async function decryptBlob(blob: ArrayBuffer, keyB64Url: string): Promise<unknown> {
  const bytes = new Uint8Array(blob)
  if (bytes.byteLength < IV_BYTES + 16) {
    throw new Error('blob too short')
  }
  const rawKey = base64urlDecode(keyB64Url)
  if (rawKey.byteLength !== KEY_BYTES) {
    throw new Error(`Expected ${KEY_BYTES}-byte key, got ${rawKey.byteLength}`)
  }
  const iv = bytes.subarray(0, IV_BYTES)
  const ciphertextWithTag = bytes.subarray(IV_BYTES)
  const key = await crypto.subtle.importKey('raw', rawKey, 'AES-GCM', false, ['decrypt'])
  const plaintext = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, ciphertextWithTag)
  return JSON.parse(new TextDecoder().decode(plaintext)) as unknown
}
